module.exports = __webpack_public_path__ + "83b7314edeada1bbc13b6225f71fc7b4.png";